export default {
  'formField': '3.75rem',
};
